<script>
export default  {
    props: {
        plannerUrl: {
            type: String,
            required: true
        },
        email: {
            type: String,
            default: ''
        },
        quotationId: {
            type: String,
            default: ''
        },
        plate: {
            type: String,
            default: ''
        },
        mileage: {
            type: String,
            default: ''
        },
        serviceName: {
            type: String,
            default: ''
        },
    },

    data() {
        return {
            hasPost: false
        }
    },

    methods: {
        handleLoaded() {
            if (this.hasPost) {
                return;
            }

            this.$refs.iframeForm.submit()
            this.hasPost = true
        }
    }
}
</script>

<template>
  <div class="vue-planner-iframe">
      <form ref="iframeForm" class="hidden" :action="plannerUrl" method="POST" target="iframe_planner">
          <input type="text" name="planner_email" :value="email">
          <input type="text" name="planner_quotationId" :value="quotationId">
          <input type="text" name="planner_plate" :value="plate">
          <input type="text" name="planner_mileage" :value="mileage">
          <input type="text" name="planner_service" :value="serviceName">
          <button type="submit">submit</button>
      </form>

      <iframe
          ref="plannerIframe"
          name="iframe_planner"
          :src="plannerUrl"
          frameborder="0"
          @load="handleLoaded"
      ></iframe>
  </div>
</template>